
if (typeof InfoLoaderProductGrids !== 'function') {
    class InfoLoaderProductGrids extends HTMLElement {
        constructor() {
            super();

            if (window.diffc_data) {
                this.productHandle = this.getAttribute('data-product-handle');
                this.parentBlock = this.closest('.product-grid') || this.closest('.product-cart-item-small');
                this.data = window.diffc_data[this.productHandle];
                this.pageElements = {};
            }
        }

        async connectedCallback() {
            if (!this.data) {
                return;
            }

            if (window.store.location && window.store.location.toLowerCase() === 'canada') {
                this.initPageElements();
                this.replacePageElements();
            }
        }

        initPageElements() {
            this.pageElements = {
                productTitle: this.parentBlock.querySelector(`[data-diffc-title]`),
                productSeoDescription: this.parentBlock.querySelector(
                    `[data-diffc-seo-description]`
                ),
                productImage: this.parentBlock.querySelector(
                    `[data-diffc-image]`
                ),
                productSmallImage: this.parentBlock.querySelector(
                    `[data-diffc-small-image]`
                )
            };
        }

        replacePageElements() {
            this.pageElements.productTitle && this.data.diffc_product_title && this.data.diffc_product_title.trim() !== ''
                ? (this.pageElements.productTitle.innerHTML = this.data.diffc_product_title)
                : null;
            this.pageElements.productSeoDescription &&
                this.data.diffc_seo_description &&
                this.data.diffc_seo_description.trim() !== ''
                ? (this.pageElements.productSeoDescription.innerHTML = this.data.diffc_seo_description)
                : null;
            this.pageElements.productImage && this.data.diffc_first_image_html_product_grid && this.data.diffc_first_image_html_product_grid !== ''
                ? (this.pageElements.productImage.outerHTML = this.data.diffc_first_image_html_product_grid)
                : null;
            this.pageElements.productSmallImage && this.data.diffc_first_image_html_product_small && this.data.diffc_first_image_html_product_small !== ''
                ? (this.pageElements.productSmallImage.outerHTML = this.data.diffc_first_image_html_product_small)
                : null;
        }
    }

    if (typeof customElements.get('info-loader-product-grids') == 'undefined') {
        customElements.define('info-loader-product-grids', InfoLoaderProductGrids);
    }
}

